  <template>
    <section class="programacion-card">
      <div v-if="tutoria" class="card-content">
        <div class="card-main-row">
          <div class="type-badge type-tutoria">
            <i class="ri-user-voice-line"></i>
            <span>{{ textoTipoClase }}</span>
          </div>

          <div v-if="textoTema" class="tema-section" :class="{ 'cancelado': tutoria.estado == 'cancelado' }">
            <i class="ri-book-open-line tema-icon"></i>
            <span class="tema-text">{{ textoTema }}</span>
            <button
              v-if="tutoria.tema && tutoria.tema.notificacion_mostrar && tutoria.tema.notificacion_texto"
              class="btn-info-small"
              @click="mostrarNotificacionTema(tutoria.tema)">
              <i class="ri-information-line"></i>
            </button>
          </div>

          <div class="status-badge" :class="estadoBadgeClass">
            <i :class="estadoIcon"></i>
            <span>{{ textoEstado }}</span>
          </div>
        </div>

        <div v-if="fechaCancelado" class="cancel-info">
          <i class="ri-time-line"></i>
          <span>{{ fechaCancelado }}</span>
        </div>

        <div class="info-compact">
          <div class="info-item-inline">
            <i class="ri-calendar-line"></i>
            <span>{{ textoFechaClase }}</span>
          </div>
          <div v-if="zonaRegional" class="info-item-inline">
            <i class="ri-time-zone-line"></i>
            <span>Zona horaria: {{ zonaRegional }}</span>
          </div>
          <div v-if="textoSede" class="info-item-inline">
            <i class="ri-map-pin-line"></i>
            <span>{{ textoSede }}</span>
          </div>
          <div
            v-if="textoSalon && mostrarSalon"
            class="info-item-inline"
            :class="{ 'salon-access-highlight': salonUrl && mostrarSalonFinal }">
            <i class="ri-door-open-line"></i>
            <strong v-if="salonUrl && mostrarSalon && mostrarSalonFinal">
              <a @click="procesarAceptar()" :href="salonUrl" target="_blank">Accede a tu clase aquí: {{ textoSalon }}</a>
            </strong>
            <span v-else>{{ textoSalon }}</span>
          </div>
          <div v-for="(docente, index) in docentesInfo" :key="index" class="info-item-inline">
            <i class="ri-user-line"></i>
            <span>{{ docente }}</span>
          </div>
        </div>

        <div v-if="textoSalon && !mostrarSalon" class="salon-notice">
          <i class="ri-information-line"></i>
          <span>{{ textoSalon }}</span>
        </div>

        <div v-if="tutoria.conformidad_fecha" class="info-secondary">
          <div class="info-item-inline">
            <i class="ri-checkbox-circle-line"></i>
            <span class="small-text">Aceptado: {{ textoConformidadFecha }}</span>
          </div>
        </div>

        <div
          v-if="puedeCancelar || ([1, 0].includes(tutoria.encuestar) && tutoria.estado == 'asistido' && tutoria.showEncuesta)"
          class="actions-section">
          <button v-if="puedeCancelar" class="btn-cancel" @click="cancelando = true">
            <i class="ri-close-circle-line"></i>
            Cancelar tutoría
          </button>
          <button
            v-if="[1, 0].includes(tutoria.encuestar) && tutoria.estado == 'asistido' && tutoria.showEncuesta"
            class="btn-survey"
            @click="mostrarEncuesta">
            <i class="ri-chat-3-line"></i>
            Encuesta
          </button>
        </div>
      </div>

      <b-modal hide-header-close v-model="cancelando" id="modalcancelarseguro" title="Cancelar tutoría"
        modal-class="modal-modern">
        <p class="mb-0">{{ textoConfirmarCancelar }}</p>
        <template #modal-footer>
          <b-btn variant="secondary" @click="cancelando = false">
            No, mantener mi tutoría
          </b-btn>
          <b-btn variant="primary" @click="procesarCancelar">
            Sí, cancelar mi tutoría
          </b-btn>
        </template>
      </b-modal>

      <b-modal no-close-on-backdrop hide-header-close ok-only ok-title="Omitir"
        v-model="mostrandoNotificacionTema" id="modalNotificacionTema" :title="tituloNotificacionTema">
        <p>{{ textoNotificacionTema }}</p>
        <br>
        <p class="text-center">
          <b-link v-if="enlaceNotificacionTema" :href="enlaceNotificacionTema" target="_blank">Más información</b-link>
        </p>
      </b-modal>

      <div v-if="mensajeTransition">
        <BlockUI :message="mensajeTransition"></BlockUI>
      </div>

      <EncuestaTutoria v-if="encuestaMostrar" :agendamiento="tutoria" @cerrar="cerrarEncuesta" :mostrar="encuestaMostrar" />
    </section>
  </template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import EncuestaTutoria from '@/features/tutorias/components/EncuestaTutoria';
  import utils from '@/modules/utils';

  export default {
    name: 'TutoriaProgramada',
    components: {
      EncuestaTutoria
    },
    props:{
      tutoria: Object,
      estudiante: Object
    },
    data () {
      return {
        tema_id_local : null,
        texto_cambio_tipo : null,
        cambiando_tema : false,
        texto_cambio_tipo: null,
        cancelando: false,
        tituloNotificacionTema:null,
        mostrandoNotificacionTema : false,
        textoNotificacionTema:null,
        enlaceNotificacionTema:'#',
        encuestaMostrar: false,
        mensajeTransition:null
      }
    },
    
    mounted () {

    },
    methods:{
      ...mapActions({
        fetchClases: 'tutoria/fetchTutorias',
        cancelar: 'tutoria/cancelar',
        aceptar: 'tutoria/aceptar'
      }),
      ...mapMutations({

      }),
      recargar(){
        this.fetchClases().then(()=>{})
      },
      
      procesarCancelar(){
        this.cancelar(this.tutoria.id).then(()=>{
        }).finally(()=>{
          this.cancelando=false
        })
      },
      procesarAceptar(){
        this.aceptar(this.tutoria.id).then(()=>{
        }).catch((error) => {
          console.error(error);
        })
      },
      docent(docente){
        if(docente){
          docente = JSON.parse(docente)
          return docente.nombre
        }
        else{return ""}
      },
      mostrarNotificacionTema(tema) {
        if (tema && tema.notificacion_mostrar && tema.notificacion_texto) {
          this.mostrandoNotificacionTema = true;
          this.textoNotificacionTema = tema.notificacion_texto
          this.enlaceNotificacionTema = tema.notificacion_enlace;
          this.tituloNotificacionTema = tema.nombre;
        }
      },
      mostrarEncuesta() {
        this.encuestaMostrar = true;
      },
      cerrarEncuesta() {
        this.tutoria.encuestar = null;
        this.encuestaMostrar = false;
      },
      addHoursToDate(objDate, intHours) {
          var numberOfMlSeconds = objDate.getTime();
          var addMlSeconds = (intHours * 60) * 60000;
          var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
          return newDateObj;
      }
    },
    computed: {
      ...mapState({
        cursos: state => state.clases.cursos, 
        sedeActual: state => state.academico.sedeActual,
      }),
      ...mapGetters({
        getCurso: 'cursos/getCursoDetalle', 
      }),

      estadoIcon() {
        const icons = {
          solicitado: 'ri-checkbox-circle-line',
          asignado: 'ri-checkbox-circle-line',
          notificado: 'ri-notification-3-line',
          cancelado: 'ri-close-circle-line',
          asistido: 'ri-check-double-line',
          ausencia: 'ri-user-unfollow-line',
          asistente: 'ri-user-follow-line',
          aceptado: 'ri-medal-line'
        };
        return icons[this.tutoria && this.tutoria.estado] || 'ri-information-line';
      },

      estadoBadgeClass() {
        const classes = {
          solicitado: 'status-confirmed',
          asignado: 'status-confirmed',
          notificado: 'status-notified',
          cancelado: 'status-cancelled',
          asistido: 'status-attended',
          ausencia: 'status-absent',
          asistente: 'status-assistant',
          aceptado: 'status-accepted'
        };
        return classes[this.tutoria && this.tutoria.estado] || 'status-default';
      },

      docentesInfo() {
        if (this.tutoria && this.tutoria.estudiante && this.tutoria.estudiante.progresos) {
          return this.tutoria.estudiante.progresos
            .filter(ag => ag.tema_id == this.tutoria.tema_id && ag.docente)
            .map(ag => this.docent(ag.docente));
        }
        return [];
      },
      
      puedeCancelar(){
        if(this.tutoria){
          if( this.tutoria.estado=='solicitado' || this.tutoria.estado=='asignado'){
            let ahora = new Date()
            if(this.tutoria.politica_cancel_tiempo){
              let deadline = new Date(this.tutoria.politica_cancel_tiempo)
              if(ahora>deadline){
                return false
              }
              return true
            }else{
              let fecha_clase = new Date(this.tutoria.clase.fecha_bloque)
              if(ahora>fecha_clase){
                return false
              }
              return true
            }
          }
        }
        return false
      },
      salonUrl() {
        if (this.tutoria.clase.salon && this.tutoria.clase.salon.url) {
          return this.tutoria.clase.salon && this.tutoria.clase.salon.url;
        }
        return null;
      },
      mostrarSalon() {
        if(this.tutoria){
          if(this.tutoria.clase && this.tutoria.clase.salon){
            let ahora = new Date()

            var dateUTC = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), ahora.getUTCHours(), ahora.getUTCMinutes(), ahora.getUTCSeconds()); 
            dateUTC = this.addHoursToDate(dateUTC, -5)// Hora local de colombia
            // let ahoraTimestamp = ahora.getTime();
            let ahoraTimestamp = dateUTC.getTime();
            let limite = new Date(ahoraTimestamp+300000)

            let fecha_bloque = new Date(this.tutoria.clase.fecha_bloque)
            let fecha_claseUTC = new Date(fecha_bloque.getUTCFullYear(), fecha_bloque.getUTCMonth(), fecha_bloque.getUTCDate(), fecha_bloque.getUTCHours(), fecha_bloque.getUTCMinutes(), fecha_bloque.getUTCSeconds()); 
            fecha_claseUTC = this.addHoursToDate(fecha_claseUTC, -5)// Hora local de colombia
            let fecha_clase = fecha_claseUTC;

            if(this.tutoria.link_activo){
              return true;
            }
          }
        }
        return false;
      },
      mostrarSalonFinal() {
        if(this.tutoria){
          if(this.tutoria.clase && this.tutoria.clase.salon){
            let ahora = new Date()

            var dateUTC = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), ahora.getUTCHours(), ahora.getUTCMinutes(), ahora.getUTCSeconds()); 
            dateUTC = this.addHoursToDate(dateUTC, -5)// Hora local de colombia
            let limite_inicial = dateUTC;

            let fecha_bloque = new Date(this.tutoria.clase.fecha_bloque)
            var dateUTCFinal = new Date(fecha_bloque.getUTCFullYear(), fecha_bloque.getUTCMonth(), fecha_bloque.getUTCDate(), fecha_bloque.getUTCHours(), fecha_bloque.getUTCMinutes(), fecha_bloque.getUTCSeconds()); 
            dateUTCFinal = this.addHoursToDate(dateUTCFinal, -5)// Hora local de colombia
            
            // let fecha_clase_final = new Date(fecha_bloque.getTime()+(300000*3))
            let fecha_clase_final = new Date(dateUTCFinal.getTime()+(300000*4))
            
            if(this.tutoria.link_activo){
              return true;
            }
          }
        }
        return false;
      },
      textoSalon(){
        if(this.tutoria){
          if(this.tutoria.estado == 'cancelado'){
            return ''
          }
          if (this.mostrarSalon) {
            if(this.tutoria.clase && this.tutoria.clase.salon){
              if(this.tutoria.clase && this.tutoria.clase.sede && this.tutoria.clase.sede.es_virtual && this.tutoria.clase.sede.es_virtual=='1'){
                if(this.tutoria.clase.salon && this.tutoria.clase.salon.url){
                  return this.tutoria.clase.salon.nombre;//`<a @click="procesarAceptar()" href="${this.tutoria.clase.salon.url}" target="_blank">${this.tutoria.clase.salon.nombre}</a>`
                }else{
                  return "Desconocido"
                }
                
              }else{
                let salon = this.tutoria.clase.salon
                let texto = salon.nombre
                return texto  
              }
            }
          }
        }
        return 'Puede verlo 5 minutos antes de la clase. Recuerde hacer click en Actualizar'
      },
      textoSede(){
        if(this.tutoria && this.tutoria.sede && this.tutoria.sede.nombre){
          return   this.tutoria.sede.nombre
        }
        return ''
      },
      textoTipoClase(){
        if(this.tutoria ){
          let texto 
          if(this.tutoria.tipo_solicitud == 'normal'){
            texto = 'Clase'
          }else if(this.tutoria.tipo_solicitud == 'tutoria'){
            texto = 'Tutoría'
          }else if(this.tutoria.tipo_solicitud == 'refuerzo'){
            texto = 'Refuerzo'
          }else if(this.tutoria.tipo_solicitud == 'asistente'){
            if(this.tutoria.tipo_clase == 'lab'){
              texto = 'Laboratorio'
            }else{
              texto = this.tutoria.tipo_clase  
            }
          }else{
            texto = this.tutoria.tipo_clase
          }
          return texto
        }
        return ''
      },
      textoTema(){
        if(this.tutoria && this.tutoria.tema){
          let texto = this.tutoria.tema.nombre
          return texto
        }
        return null
      },
      observaciones(){
        if(this.tutoria && this.tutoria.observaciones){
          return  JSON.parse(this.tutoria.observaciones)
        }
        return null
      },
      textoFechaClase(){
        if(this.tutoria && this.tutoria.clase){
          if ([17,30].includes(this.tutoria.clase.sede_id) && this.userTimeZone !== 'America/Bogota') {
            return utils.getDateTime(this.tutoria.clase.fecha_bloque)
          } else {
            let fechaBloque = new Date(this.tutoria.clase.fecha_bloque)
            let texto = fechaBloque.toLocaleString('es-CO', {timeZone:"America/Bogota"})
            return texto
          }
        }
        return ''
      },
      textoAsistenciaFecha(){
        if(this.tutoria && this.tutoria.asistencia_fecha){
          if (this.tutoria && this.tutoria.clase && [17,30].includes(this.tutoria.clase.sede_id) && this.userTimeZone !== 'America/Bogota') {
            return utils.getDateTime(this.tutoria.asistencia_fecha)
          } else {
            let asistencia_fecha = new Date(this.tutoria.asistencia_fecha).toLocaleString('es-CO', {timeZone:"America/Bogota"})
            return asistencia_fecha
          }
        }
        return null
      },
      observacionCancelado(){
        if(this.tutoria){
          if(this.tutoria.estado=='cancelado'){
            if(this.tutoria.observaciones){
              let observaciones = JSON.parse(this.tutoria.observaciones)
              let ultimaObservacion = observaciones.pop()
              if(ultimaObservacion && ultimaObservacion.texto){
                if(ultimaObservacion.texto.indexOf('Cancelado')>=0){
                  return ultimaObservacion
                }
              }
              
            }
          }
        }
        return null
      },
      fechaCancelado(){
        let observacionCancelado = this.observacionCancelado
        if(observacionCancelado && observacionCancelado.fecha){
          if (this.tutoria && this.tutoria.clase && [17,30].includes(this.tutoria.clase.sede_id) && this.userTimeZone !== 'America/Bogota') {
            return utils.getDateTime(observacionCancelado.fecha)
          } else {
            let fechaCancelado = new Date(observacionCancelado.fecha)
            if (fechaCancelado.toString() === 'Invalid Date') return observacionCancelado.fecha;
            return fechaCancelado.toLocaleString('es-CO', {timeZone:"America/Bogota"})
          }
        }
        return null
      },
      textoEstado(){
        if(this.tutoria){
          if(this.tutoria.estado=='solicitado'){
            return 'Confirmado'
          }else if(this.tutoria.estado=='asignado'){
            return 'Confirmado'
          }else if(this.tutoria.estado=='notificado'){
            return 'Notificado'
          }else if(this.tutoria.estado=='cancelado'){
            let canceladoTexto = 'Cancelado'
            let observacionCancelado = this.observacionCancelado
            if(observacionCancelado && observacionCancelado.texto){
              canceladoTexto = observacionCancelado.texto
            }
            return canceladoTexto
          }else if(this.tutoria.estado=='asistido'){
            return 'Confirmado'
          }else if(this.tutoria.estado=='ausencia'){
            return 'Ausente'
          }else if(this.tutoria.estado=='asistente'){
            return 'Asistente'
          }else if(this.tutoria.estado=='aceptado'){
            return 'Aceptado'
          }else{
            return this.tutoria.estado
          }  
        }
        return ''
      },
      textoConformidadFecha(){
        if(this.tutoria && this.tutoria.conformidad_fecha){
          if (this.tutoria && this.tutoria.clase && [17,30].includes(this.tutoria.clase.sede_id) && this.userTimeZone !== 'America/Bogota') {
            return utils.getDateTime(this.tutoria.conformidad_fecha)
          } else {
            let conformidad_fecha = new Date(this.tutoria.conformidad_fecha).toLocaleString('es-CO', {timeZone:"America/Bogota"})
            return conformidad_fecha
          }
        }
        return 'Pendiente'
      },
      textoConfirmarCancelar(){
        let texto =  "¡RECUERDA! solo podrás CANCELAR esta tutoria con 8 HORAS de anticipación. Esto con el fin de que otros compañeros tengan el cupo abierto y puedan programar sus tutorias. No dejes de Avanzar."
        return texto + ' ¿Estás seguro que deseas cancelar tu tutoria de '+this.textoFechaClase+'?'
      },
      
      textoPoliticaCancelacion(){
        if(this.tutoria.estado!='cancelado'){
          return this.tutoria.politica_cancel_mensaje ? this.tutoria.politica_cancel_mensaje : false;  
        }
        return false
      },
      zonaRegional() {
        if (this.tutoria && this.tutoria.clase && [17,30].includes(this.tutoria.clase.sede_id) && this.userTimeZone !== 'America/Bogota') {
          return `${this.userTimeZone}`;
        } else {
          return 'América/Bogotá';
        }
      },
      userTimeZone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    }
  }
</script>

<style scoped>
.programacion-card {
  width: 100%;
}

.card-content {
  padding: 0.75rem 1rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 10px;
  box-shadow: var(--theme-shadow-sm);
  transition: all 0.2s ease;
}

.card-content:hover {
  border-color: var(--app-primary-blue);
  box-shadow: var(--theme-shadow-md);
}

.card-main-row,
.info-compact,
.info-secondary,
.actions-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.card-main-row {
  margin-bottom: 0.5rem;
}

.type-badge,
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border: none;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.type-badge {
  background: var(--theme-hover-bg-light);
  border-color: var(--theme-border-color);
  color: var(--app-primary-blue);
}

.status-confirmed,
.status-attended,
.status-accepted {
  background: rgba(34, 197, 94, 0.15);
  border-color: rgba(34, 197, 94, 0.3);
  color: var(--app-color-green);
}

.status-notified {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
  color: var(--theme-text-primary);
}

.status-cancelled {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.3);
  color: var(--app-primary-red);
}

.status-absent,
.status-assistant {
  background: var(--theme-hover-bg-light);
  border-color: var(--theme-border-color);
  color: var(--theme-text-secondary);
}

.status-default {
  background: var(--theme-hover-bg-light);
  border-color: var(--theme-border-color);
  color: var(--theme-text-secondary);
}

.tema-section {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;
}

.tema-icon {
  flex-shrink: 0;
  color: var(--app-primary-blue);
  font-size: 1rem;
}

.tema-text {
  overflow: hidden;
  flex: 1;
  color: var(--theme-text-primary);
  font-size: 0.875rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tema-section.cancelado .tema-text {
  text-decoration: line-through;
  opacity: 0.6;
}

.btn-info-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  padding: 0;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 4px;
  color: var(--app-primary-blue);
  cursor: pointer;
}

.cancel-info,
.info-item-inline,
.policy-alert,
.salon-notice {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--theme-text-secondary);
  font-size: 0.8rem;
}

.salon-access-highlight {
  padding: 0.45rem 0.65rem;
  background: var(--theme-input-focus);
  border: 1px solid var(--theme-border-color);
  border-radius: 8px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.salon-access-highlight a {
  color: var(--theme-color-info);
  font-weight: 600;
}

html.dark-theme .salon-access-highlight a {
  color: var(--theme-text-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.cancel-info {
  margin-bottom: 0.5rem;
  color: var(--app-primary-red);
}

.info-compact {
  padding: 0.5rem 0;
  border-top: 1px solid var(--theme-border-color-light);
}

.salon-notice {
  width: 100%;
  padding: 0.5rem 0.625rem;
  margin-top: 0.25rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 6px;
}

.info-item-inline i,
.cancel-info i,
.policy-alert i {
  flex-shrink: 0;
  color: var(--app-primary-blue);
}

.info-item-inline span,
.info-item-inline strong {
  color: var(--theme-text-secondary);
  font-size: 0.8rem;
  font-weight: 500;
}

.info-item-inline a {
  color: var(--app-primary-blue);
  font-weight: 600;
}

.info-secondary {
  padding-top: 0.5rem;
  border-top: 1px solid var(--theme-border-color-light);
}

.small-text {
  font-size: 0.75rem !important;
}

.policy-alert {
  width: 100%;
  padding: 0.5rem 0.625rem;
  margin-top: 0.5rem;
  background: var(--theme-hover-bg-light);
  border: 1px solid var(--theme-border-color);
  border-radius: 6px;
}

.actions-section {
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  border-top: 1px solid var(--theme-border-color-light);
}

.btn-cancel,
.btn-survey {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.btn-cancel:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.btn-survey {
  background: var(--theme-gradient-primary);
  color: white;
}

.btn-survey:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(13, 78, 140, 0.3);
}

.btn-info-small:hover {
  transform: translateY(-1px);
  box-shadow: var(--theme-shadow-sm);
}

@media (max-width: 480px) {
  .card-content {
    padding: 0.75rem;
  }

  .tema-section {
    flex-basis: 100%;
    order: 3;
  }

  .info-item-inline {
    width: 100%;
  }
}
</style>
<style src="../../../assets/styles/shared-modals.css"></style>